// GENERATED by scripts/textures3d/build-textures.mjs — do not edit by hand.
import s_brick from "./swatches/brick.webp?url";
import s_carpet from "./swatches/carpet.webp?url";
import s_ceiling_planks from "./swatches/ceiling-planks.webp?url";
import s_concrete from "./swatches/concrete.webp?url";
import s_deck from "./swatches/deck.webp?url";
import s_floor_herringbone from "./swatches/floor-herringbone.webp?url";
import s_floor_oak from "./swatches/floor-oak.webp?url";
import s_floor_porcelain from "./swatches/floor-porcelain.webp?url";
import s_floor_stone from "./swatches/floor-stone.webp?url";
import s_floor_walnut from "./swatches/floor-walnut.webp?url";
import s_floor_whitewash from "./swatches/floor-whitewash.webp?url";
import s_grass from "./swatches/grass.webp?url";
import s_gravel from "./swatches/gravel.webp?url";
import s_masonry from "./swatches/masonry.webp?url";
import s_oak from "./swatches/oak.webp?url";
import s_painted_wood from "./swatches/painted-wood.webp?url";
import s_pavers from "./swatches/pavers.webp?url";
import s_plaster from "./swatches/plaster.webp?url";
import s_plaster_rough from "./swatches/plaster-rough.webp?url";
import s_shiplap from "./swatches/shiplap.webp?url";
import s_stucco from "./swatches/stucco.webp?url";
import s_terrazzo from "./swatches/terrazzo.webp?url";
import s_wall_tile from "./swatches/wall-tile.webp?url";
import s_walnut from "./swatches/walnut.webp?url";

export interface SwatchTexture {
  url: string;
  tint: "detail" | "colored";
  /** Mean linear color of a `colored` scan: the tint is applied relative to it. */
  mean?: readonly [number, number, number];
}

/** Texture set id → thumbnail for the room finishes picker. */
export const SWATCH_TEXTURES: Record<string, SwatchTexture> = {
  "brick": { url: s_brick, tint: "colored", mean: [0.361, 0.2019, 0.1312] },
  "carpet": { url: s_carpet, tint: "detail" },
  "ceiling-planks": { url: s_ceiling_planks, tint: "detail" },
  "concrete": { url: s_concrete, tint: "detail" },
  "deck": { url: s_deck, tint: "colored", mean: [0.1652, 0.0376, 0.0059] },
  "floor-herringbone": { url: s_floor_herringbone, tint: "colored", mean: [0.2822, 0.1676, 0.0986] },
  "floor-oak": { url: s_floor_oak, tint: "colored", mean: [0.2176, 0.1175, 0.0554] },
  "floor-porcelain": { url: s_floor_porcelain, tint: "colored", mean: [0.4114, 0.3201, 0.2383] },
  "floor-stone": { url: s_floor_stone, tint: "colored", mean: [0.6132, 0.6133, 0.611] },
  "floor-walnut": { url: s_floor_walnut, tint: "colored", mean: [0.0309, 0.0201, 0.0103] },
  "floor-whitewash": { url: s_floor_whitewash, tint: "colored", mean: [0.7488, 0.559, 0.3303] },
  "grass": { url: s_grass, tint: "colored", mean: [0.1269, 0.1612, 0.0343] },
  "gravel": { url: s_gravel, tint: "colored", mean: [0.7066, 0.6805, 0.6271] },
  "masonry": { url: s_masonry, tint: "colored", mean: [0.2407, 0.2406, 0.2386] },
  "oak": { url: s_oak, tint: "detail" },
  "painted-wood": { url: s_painted_wood, tint: "detail" },
  "pavers": { url: s_pavers, tint: "colored", mean: [0.361, 0.3367, 0.2777] },
  "plaster": { url: s_plaster, tint: "detail" },
  "plaster-rough": { url: s_plaster_rough, tint: "detail" },
  "shiplap": { url: s_shiplap, tint: "detail" },
  "stucco": { url: s_stucco, tint: "detail" },
  "terrazzo": { url: s_terrazzo, tint: "colored", mean: [0.7065, 0.6696, 0.6309] },
  "wall-tile": { url: s_wall_tile, tint: "detail" },
  "walnut": { url: s_walnut, tint: "detail" },
};
